var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("台灣Pay付款說明")]),_c('ul',{staticClass:"has-type-decimal"},[_c('li',[_vm._v("使用台灣Pay恕不適用分期付款。")]),_c('li',[_vm._v("台灣Pay限使用金融卡/帳戶付款。")]),_c('li',[_vm._v("台灣Pay付款有效時間：於訂單成立後 10 分鐘內，須完成付款。")]),_c('li',[_vm._v("單筆訂單金額上限依各銀行單筆/單日交易限制。")])])])
}]

export { render, staticRenderFns }